import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=14090852&scoped=true&"
import script from "./ContentCard.vue?vue&type=script&lang=js&"
export * from "./ContentCard.vue?vue&type=script&lang=js&"
import style0 from "./ContentCard.vue?vue&type=style&index=0&id=14090852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14090852",
  null
  
)

export default component.exports
import {QCard,QMenu,QItem,QItemSection,QSeparator,QIcon,QTooltip,QDialog,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QMenu,QItem,QItemSection,QSeparator,QIcon,QTooltip,QDialog})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
